module.exports = __webpack_public_path__ + "static/media/MacPortrait2w300@2x.d6567514.webp";